// White Label Configuration
// This file contains all configurable white label-related settings

const defaultWhiteLabelConfig = {
  agencyName: 'Consolto',
  agencyDomain: 'consolto.com',
  agencyWebsite: 'https://www.consolto.com',
  emails: {
    contact: 'info@consolto.com',
    support: 'support@consolto.com',
  },
  agencyTerms: 'https://www.consolto.com/legal/terms-of-use',
  agencyPrivacyPolicy: 'https://www.consolto.com/legal/privacy',
  // urls: {
  //   homepage: 'https://www.consolto.com',
  //   documentation: 'https://www.consolto.com/documentation',
  //   knowledgeBase: 'https://www.consolto.com/knowledge-posts',
  //   appStore: 'https://apps.apple.com/us/app/consolto-video-chat/id1584996493',
  //   playStore: 'https://play.google.com/store/apps/details?id=com.consolto.app',
  // },
};

// This can be overridden by environment variables or external configuration
const getWhiteLabelConfig = () => {
  // In a real implementation, this could load from:
  // - Environment variables
  // - External configuration service
  // - Database settings
  // - Local storage for client-specific settings

  const customConfig = {
    // Override default values here for white labeling
    // agencyName: process.env.REACT_APP_WHITE_LABEL_NAME || defaultWhiteLabelConfig.agencyName,
    // agencyDomain: process.env.REACT_APP_WHITE_LABEL_DOMAIN || defaultWhiteLabelConfig.agencyDomain,
    // agencyWebsite: process.env.REACT_APP_WHITE_LABEL_WEBSITE || defaultWhiteLabelConfig.agencyWebsite,
    // etc.
  };

  return {
    ...defaultWhiteLabelConfig,
    ...customConfig,
  };
};

export {defaultWhiteLabelConfig};
export default getWhiteLabelConfig();
